import { BaseModel } from "@models/base.model"
import { computed, makeObservable, observable } from "mobx"
import { Localization } from "@serializers/localization"
import { htmlToTextTransform } from "@lib/html"

import type { Vacancy } from "../providers/vacancies.provider"

export class VacanciesModel extends BaseModel {
  constructor(params) {
    super(params)
    makeObservable(this)
  }

  @observable templates: Localization[] = []
  @observable departments: Department[] = []
  @observable vacancies: Vacancy[] = []
  @observable vacancy = null as Vacancy | null

  @computed get existVacanciesCount() {
    return this.vacancies.length
  }

  getVacanciesPage = async () => {
    try {
      const {
        templates,
      } = await this.Providers.VacanciesProvider.getCareersTemplates(
        this.Models.GlobalModel.lang,
      )
      this.applyData({ templates })
    } catch {}
  }

  getTemplate = (key: string, simpleText = true) => {
    const find = this.templates.find((template) => template.key === key)
    if (!find) return ""

    return simpleText ? htmlToTextTransform(find.template) : find.template
  }

  getDepartments = async () => {
    try {
      const departments = await this.Providers.DepartmentsProvider.getDepartments()
      this.applyData({ departments })
    } catch {}
  }

  getVacancies = async () => {
    try {
      const {
        vacancies,
      } = await this.Providers.VacanciesProvider.getVacancies()
      this.applyData({ vacancies })
    } catch {}
  }

  getVacancy = async (id: string | number) => {
    const vacancy = await this.Providers.VacanciesProvider.getVacancy(id)
    this.applyData({ vacancy })
  }

  hydrate = (data: unknown) => {
    // @ts-ignore
    this.applyData({ templates: data?.templates })
    // @ts-ignore
    this.applyData({ vacancies: data?.vacancies })
    // @ts-ignore
    this.applyData({ vacancy: data?.vacancy })
    // @ts-ignore
    this.applyData({ departments: data?.departments })
  }

  serialize = () => {
    return {
      templates: this.templates,
      vacancies: this.vacancies,
      vacancy: this.vacancy,
      departments: this.departments,
    }
  }

  createJobRequest = async (
    data: JobRequestData,
  ): Promise<{
    applicationSent: boolean
    emailSent?: boolean
    error?: Error
  }> => {
    const {
      vacancy_id,
      vacancy_title,
      name,
      surname,
      email,
      phone,
      linkedin,
      source,
      files,
    } = data
    try {
      const response = await this.Providers.VacanciesProvider.sendRequest({
        name,
        surname,
        email,
        phone,
        linkedin,
        source,
        files,
        vacancy_id,
        vacancy_title,
      })
      return {
        applicationSent: Boolean(response.applicationSent),
        emailSent: Boolean(response.emailSent),
        error: response.error,
      }
    } catch (error) {
      return {
        applicationSent: false,
        error: error,
      }
    }
  }
}

interface JobRequestData {
  vacancy_id: string
  vacancy_title: string
  name: string
  surname: string
  email: string
  phone: string
  linkedin: string
  source: string
  files: File[]
}

interface Department {
  id: number
  title: string
  order: number
}
